"use strict";

(function (Drupal) {
  Drupal.behaviors.dartmouthA11y = {
    attach: function attach(context, settings) {
      // on tab add class
      var tabHelper = function tabHelper() {
        if (document.body.classList.contains('is-a11y')) {
          return;
        }
        document.body.classList.add('is-a11y');
      };
      document.body.addEventListener('keydown', function (e) {
        if (e.keyCode == 9) {
          tabHelper();
        }
      });
    }
  };
})(Drupal);